// // 半角 - 16进制：\u0021-\u007e，10进制：33-126
// const halfAnglePunctuation = (str: string) => {
//   return str.charCodeAt(0) <= 126 && str.charCodeAt(0) >= 33
// }
// // 全角 \uff01-\uff5e
// const allAnglePunctuation = (str: string) => {
//   return str.charCodeAt(0) <= 65374 && str.charCodeAt(0) >= 65281
// }

// // 引号
// const isQuotationMark = (str: string) => {
//   return str.charCodeAt(0) <= 8223 && str.charCodeAt(0) >= 8216
// }

// 半角符号：[\u0021-\u002f]|[\u003a-\u003f]|\u0040|[\u005b-\u005f]|\u0060|[\u007b-\u007e]
const halfAngleSymbolUnicode =
  '[\u0021-\u002f]|[\u003a-\u003f]|\u0040|[\u005b-\u005f]|\u0060|[\u007b-\u007e]'
// 没有]符号
const noBracketHalfAngleSymbolUnicode =
  '[\u0021-\u002f]|[\u003a-\u003f]|\u0040|\u005b|\u005c|\u005e|\u005f|\u0060|[\u007b-\u007e]'
// 全角符号: [\uff01-\uff0f]|[\uff1a-\uff1f]|\uff20|[\uff3b-\uff3f]|\uff40|[\uff5b-\uff5f]
const allAngleSymbolUnicode =
  '[\uff01-\uff0f]|[\uff1a-\uff1f]|\uff20|[\uff3b-\uff3f]|\uff40|[\uff5b-\uff5f]'
// 中日韩标点符号和句号: \u3001|\u3002|[\u3001-\u300f]
const otherSymbolUnicode = '[\u3001-\u300f]'
// 所有符号: [\u0021-\u002f]|[\u003a-\u003f]|\u0040|[\u005b-\u005f]|\u0060|[\u007b-\u007e]｜[\uff01-\uff0f]|[\uff1a-\uff1f]|\uff20|[\uff3b-\uff3f]|\uff40|[\uff5b-\uff5f]|\u3001|\u3002|[\u3001-\u300f]
// 没有》符号
const nobracketOtherSymbolUnicode = '[\u3001-\u300a]|[\u300c-\u300f]'
const allSymbol = `${halfAngleSymbolUnicode}|${allAngleSymbolUnicode}|${otherSymbolUnicode}`
const noBracketAllSymbol = `${noBracketHalfAngleSymbolUnicode}|${allAngleSymbolUnicode}|${nobracketOtherSymbolUnicode}`
// // 句号-12290 16:3002,顿号-12289 16:3001
export const removeSplitSymbol = (str: string) => {
  return str.replace(/_|---|\||——/g, '-')
}
function hexToString(str: string) {
  let val = ''
  const arr = str.split(',')
  for (let i = 0; i < arr.length; i += 1) {
    val += String.fromCharCode(parseInt(arr[i], 10))
  }
  return val
}

export default class Title {
  constructor(title: string) {
    this.title = title
  }

  title: string

  toString() {
    return this.title
  }

  removeSplitSymbol() {
    this.title = removeSplitSymbol(this.title)
    return this
  }

  // 多个空格替换为一个空格
  deleteUnnecessarySpace() {
    this.title = this.title.replace(/\s{2,}/g, ' ')
    return this
  }

  // 删除标点前后空格
  deleteNearSymbolSpace() {
    this.replaceAll(
      [
        new RegExp(`\\s(${allSymbol})`, 'g'),
        new RegExp(`(${allSymbol})\\s`, 'g'),
      ],
      '$1'
    )
    return this
  }

  // 异形括号内文字大于4删除括号
  deleteBracketsData() {
    this.replaceAll(
      [
        /﹛(.{5,})﹜/g,
        /『(.{5,})』/g,
        /〖(.{5,})〗/g,
        /［(.{5,})］/g,
        /【(.{5,})】/g,
        /「(.{5,})」/g,
      ],
      '$1'
    )
    return this
  }

  // 异形括号文字小于4个，替换异形括号
  replaceBrackets() {
    this.title = this.title
      .replace(/(﹛|『|〖|［|【|「)/g, '[')
      .replace(/(﹜|』|〗|］|】|」)/g, ']')
    return this
  }

  replaceSingleBracket() {
    this.replaceBookNameSymbol('《', '》')
    this.replaceBookNameSymbol('[', ']')
    this.replaceBookNameSymbol('“', '”')
    this.replaceBookNameSymbol('‘', '’')
    this.replaceBookNameSymbol('〈', '〉')
    return this
  }

  // 中文句号改空格
  replaceEndSymbolWithSpace() {
    this.title = this.title.replace(/。/g, ' ')
    return this
  }

  // 替换英文后跟的全角符号
  replaceAllAnglePunctuation() {
    const arr =
      this.title
        .match(new RegExp(`[a-zA-Z](${allAngleSymbolUnicode})`, 'g'))
        ?.map((item) => {
          const fullSymbolNum = item.charCodeAt(item.length - 1)
          const halfSymbolNum = fullSymbolNum - 65248
          const halfSymbol = hexToString(`${halfSymbolNum}`)
          return item.substring(0, item.length - 1) + halfSymbol
        }) || []
    // const holdArr = this.title.split(reg)
    const holdArr = this.title.split(
      new RegExp(`[a-zA-Z](${allAngleSymbolUnicode})`, 'g')
    )
    this.title = holdArr.reduce((pre, current, currentIndex) => {
      if (currentIndex % 2 !== 0) {
        return pre + (arr[(currentIndex - 1) / 2] || '')
      }
      return `${pre}${current}`
    })
    return this
  }
  // 替换中文后跟的半角符号

  replaceHalfAnglePunctuation() {
    // console.log(this.title, 'this.title')
    const arr =
      this.title
        .match(new RegExp(`[\u4e00-\u9fa5](${halfAngleSymbolUnicode})`, 'g'))
        ?.map((item) => {
          const halfSymbolNum = item.charCodeAt(item.length - 1)
          const fullSymboNum = halfSymbolNum + 65248
          const fullSymbo = hexToString(`${fullSymboNum}`)
          return item.substring(0, item.length - 1) + fullSymbo
        }) || []
    // console.log(arr, 'arr')
    const holdArr = this.title.split(
      new RegExp(`[\u4e00-\u9fa5](${halfAngleSymbolUnicode})`, 'g')
    )
    // console.log(holdArr, 'holdArr')
    this.title = holdArr.reduce((pre, current, currentIndex) => {
      if (currentIndex % 2 !== 0) {
        return pre + (arr[(currentIndex - 1) / 2] || '')
      }
      return `${pre}${current}`
    })
    return this
  }

  replaceAll(regArr: RegExp[], replaceString: string) {
    regArr.forEach((item) => {
      this.title = this.title.replace(item, replaceString)
    })
    return this
  }

  replace(reg: string | RegExp, content: string) {
    this.title = this.title.replace(reg, content)
    return this
  }

  replaceMoreAndMore() {
    this.replace(new RegExp(`(${noBracketAllSymbol})+……`, 'g'), '……')
    return this
  }

  // 替换未成对的符号号
  replaceBookNameSymbol(leftSymbol: string, rightSymbol: string) {
    const s = this.title
    let arr = s.split('')
    const stack = []
    let hasLeftSymbol = false
    for (let i = 0; i < arr.length; i += 1) {
      const item = arr[i]
      if (item === leftSymbol) {
        stack.push(i)
        hasLeftSymbol = true
      } else if (item === rightSymbol) {
        if (stack.length && arr[stack[stack.length - 1]] !== ')') {
          stack.pop()
        } else {
          stack.push(i)
        }
      }
    }
    while (stack.length) {
      const item = stack.pop()
      if (item !== undefined) {
        arr[item] = ''
      }
    }
    if (!hasLeftSymbol) {
      arr = arr.filter((item) => item !== rightSymbol)
    }
    this.title = arr.join('')
    return this
  }
}
